import { useEffect, useState } from 'react';
import styles from './style.module.css';
import Sidebar from './Sidebar';
import TotalAcc from './TotalAcc';
import Detail from './Detail';
import Confusion from './Confusion';
import useApi from '../../services/useApi';

export default function Dashboard(){
    const [isListLoad,setIsListLoad]=useState(true);
    const [modelList,setModelList]=useState([]);
    const [testSetList,setTestSetList]=useState([]);
    const [checkedModels,setCheckedModels]=useState([]);
    const [checkedTests,setCheckedTests]=useState([]);
    const [dashboardData,setDashboardData]=useState([]);
    const [exportData,setExportData]=useState([]);

    useEffect(()=>{
        useApi.get('backboard/model/dashboard').then((res)=>{
            setModelList(res.data);
            setCheckedModels(res.data.map(item=>item.modelId));
            setIsListLoad(false)
        }).catch(function (thrown) {
        });
        useApi.get('backboard/datasets/dashboards').then((res)=>{
            setTestSetList(res.data);
            setCheckedTests(res.data.map(item=>item.datasetId));
        }).catch(function (thrown) {
        });
    },[])

    useEffect(()=>{
        useApi.get('backboard/results/dashboards').then((res)=>{
            setDashboardData(res.data)
        }).catch(function (thrown) {
        });
    },[checkedModels,checkedTests])

    const downloadChartDataAsCSV = () => {
        if (!exportData || exportData.length === 0) return;
      
        let csvContent = 'testName,modelName,accuracy\n';
      
        exportData.forEach(line => {
          line.data.forEach(point => {
            csvContent += `${line.id},${point.x},${point.y}\n`;
          });
        });
      
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
      
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'line_chart_data.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return(
        <div className={styles['wrap']}>
            <Sidebar
            isLoad={isListLoad}
            modelList={modelList}
            checkedModels={checkedModels}
            setCheckedModels={setCheckedModels}
            testSetList={testSetList}
            checkedTests={checkedTests}
            setCheckedTests={setCheckedTests}
            />
            <div className={styles['body']}>
                <header>
                    <span>Dashboard</span>
                    <button onClick={downloadChartDataAsCSV}>Export to CSV</button>
                </header>
                <TotalAcc
                dashboardData={dashboardData}
                modelList={modelList}
                checkedModels={checkedModels}
                testSetList={testSetList}
                checkedTests={checkedTests}
                setExportData={setExportData}
                />
                {/* <Detail/> */}
                <Confusion
                dashboardData={dashboardData}
                modelList={modelList}
                checkedModels={checkedModels}
                testSetList={testSetList}
                checkedTests={checkedTests}
                />
            </div>
        </div>
    )
}